import { ForwardedRef, forwardRef } from 'react';
import { RootComponent } from '../../root-component';
import { Props } from '../types';

/**
 * Неинтерактивный элемент
 */
export const NonInteractive = forwardRef(function NonInteractive<T>(
  {
    /**
     * 💬 Явно убираем те `props`,
     * которые относятся к интерактивного элементу
     */
    href,
    hasHover,
    shouldForceHovered,
    hoverClassName,
    hasActive,
    shouldForceActivated,
    activeClassName,
    activeEffectDelay,
    onClick,
    onCanPlayCapture,
    ...props
  }: Props<T>,
  forwardedRef: ForwardedRef<T>
) {
  return <RootComponent {...props} ref={forwardedRef} />;
});
